<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight" style="background-size: cover; background-position:center;"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'forms-header.jpg)'}">
        <div class="row">
            <div style="width:10%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:80%">
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">FORMS
                </h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">THE FORMS YOU NEED TO GET GROWING</h1>
            </div>
            <div style="width:10%"></div>
        </div>
    </div>
    <div class="whiteBackground mb-5" style="text-align: left; margin-left:10%; margin-right:10%;">
        <div class="row mt-5 text-center">
            <h2 class="DINNextLTPro-Black greenText" style="font-size:43px; font-weight: 900; letter-spacing: -.86px; ">
                FORMS</h2>
        </div>
        <div class="row mt-2 mb-3 text-center">
            <h2 class="DIN2014Regular blackText"
                style="font-size:19px; line-height:30px; font-weight: 400; letter-spacing: .38px; ">Quickly find and
                complete the necessary documents for your needs. Our Forms Center provides easy access to all essential
                paperwork.</h2>
        </div>
        <div *ngFor="let form of this.allForms" style="border-bottom:solid 1px grey;">
            <div class="row mb-2 pt-3">
                <div class="col-md-6">
                    <h6 class="DIN2014Bold" style="font-size:26px; font-weight:700;">
                        {{form.DisplayName}}</h6>
                </div>
                <div class="col-md-6" style="text-align: right;">
                    <a class="DIN2014Bold greenBackground whiteText"
                        style="font-size:20px; font-weight:700; padding:12px; text-decoration: none !important"
                        href="{{ basePath + form.FilePath}}" target="_blank">DOWNLOAD</a>
                </div>
            </div>
        </div>
    </div>
</div>